import { z } from 'zod'

/** POST /api/admin/test-email — one address, nothing else. */
export const testEmailSchema = z.object({
  to: z.string().trim().min(3).max(200).email('Bitte eine gültige E-Mail-Adresse angeben.'),
})
export type TestEmailInput = z.infer<typeof testEmailSchema>
